import { render, staticRenderFns } from "./LayoutPreview.vue?vue&type=template&id=4fe42bc1&scoped=true"
import script from "./LayoutPreview.vue?vue&type=script&lang=js"
export * from "./LayoutPreview.vue?vue&type=script&lang=js"
import style0 from "./LayoutPreview.vue?vue&type=style&index=0&id=4fe42bc1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe42bc1",
  null
  
)

export default component.exports